import type { ImgixAvatarElement } from '@/apis/repositories/models/derek'
import type { PlannerID } from '@/types/app'
import { createAvatarFromImgixAvatarElement } from './plannerAvatar'

export const parseMaybeAvatarImage = (
  plannerId: PlannerID,
  maybeImage: Maybe<ImgixAvatarElement>
): Maybe<ReturnType<typeof createAvatarFromImgixAvatarElement>> =>
  maybeImage && createAvatarFromImgixAvatarElement(plannerId, maybeImage)
